const lessonCss = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700&display=swap');
.jtbd-lesson, .jtbd-lesson * { box-sizing: border-box; }
.jtbd-lesson {
  margin: 0;
  background: #ececec;
  color: #000;
  font-family: Inter, sans-serif;
}
.jtbd-lesson .page {
  width: 100%;
  max-width: min(1301px, 100%);
  margin: 0 auto;
  padding: 24px 16px 40px;
  min-width: 0;
}
.jtbd-lesson .frame {
  background: #fff;
  border-radius: 20px;
  padding: 43px 38px 63px 38px;
}
.jtbd-lesson .frame-title {
  margin: 0;
  font-size: 25px;
  font-weight: 700;
  line-height: 1.18;
}
.jtbd-lesson .frame-lead {
  margin: 16px 0 0;
  font-size: 20px;
  font-weight: 400;
  line-height: 1.15;
}
.jtbd-lesson .frame-lead p { margin: 0 0 0.85em; }
.jtbd-lesson .frame-lead p:last-child { margin-bottom: 0; }
/* Пустой абзац из редактора — это пустая строка; не даём ему схлопнуться в ноль */
.jtbd-lesson .frame-lead p:empty { margin: 0; min-height: 1.15em; }
.jtbd-lesson .frame-lead ul { margin: 0; padding-left: 1.35em; }
.jtbd-lesson .frame-lead li { margin: 0; }
.jtbd-lesson .frame-lead strong { font-weight: 700; }
.jtbd-lesson .card {
  margin-top: 30px;
  background: #fff;
  border: 1px solid #000;
  border-radius: 20px;
}
.jtbd-lesson .card-title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
}
.jtbd-lesson .caption {
  margin: 4px 0 0;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.2;
}
.jtbd-lesson .text-para { margin: 0 0 0.8em; }
.jtbd-lesson .text-para:last-child { margin-bottom: 0; }
.jtbd-lesson .item-title {
  margin: 14px 0 0;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.2;
  white-space: pre-line;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.jtbd-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 100000;
  background: rgba(0, 0, 0, 0.55);
  opacity: 0;
  transition: opacity 0.35s ease;
}
.jtbd-modal-backdrop.is-open { opacity: 1; }
.jtbd-modal {
  position: fixed;
  z-index: 100001;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background: #111;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.35);
  transition: top 0.45s cubic-bezier(0.2, 0.75, 0.2, 1), left 0.45s cubic-bezier(0.2, 0.75, 0.2, 1), width 0.45s cubic-bezier(0.2, 0.75, 0.2, 1), height 0.45s cubic-bezier(0.2, 0.75, 0.2, 1), border-radius 0.45s ease;
}
.jtbd-modal-player {
  position: relative;
  flex: 0 0 auto;
  width: 100%;
  background: #000;
  aspect-ratio: 16 / 9;
}
.jtbd-modal-player > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.jtbd-modal-head {
  flex: 0 0 auto;
  background: #fff;
  color: #000;
  padding: 14px 48px 12px 18px;
  opacity: 0;
  transition: opacity 0.15s ease;
}
.jtbd-modal.is-open .jtbd-modal-head { opacity: 1; transition-delay: 0.2s; }
.jtbd-modal-meta {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  padding: 14px 18px 18px;
  background: #fff;
  color: #000;
  opacity: 0;
  transition: opacity 0.15s ease;
}
.jtbd-modal.is-open .jtbd-modal-meta { opacity: 1; transition-delay: 0.2s; }
.jtbd-modal-chapters { margin: 0 0 12px; }
.jtbd-modal-chapters a {
  color: inherit;
  font-weight: 700;
  text-decoration: none;
}
.jtbd-modal-chapter { margin: 0 0 6px; font: 400 14px/1.3 Inter, sans-serif; }
.jtbd-modal-title {
  margin: 0;
  font: 700 18px/1.25 Inter, sans-serif;
}
.jtbd-modal-desc {
  margin: 8px 0 0;
  font: 400 14px/1.35 Inter, sans-serif;
  white-space: pre-line;
}
.jtbd-modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  font: 20px/1 Inter, sans-serif;
  cursor: pointer;
}
/* Попап картинки: без карточки и фона — только изображение в оверлее
   и название под ним белым текстом */
.jtbd-modal--image {
  position: fixed;
  inset: 0;
  z-index: 100001;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;
  padding: 40px 40px 96px;
  opacity: 0;
  transition: opacity 0.25s ease;
  pointer-events: none;
  overflow: hidden;
}
.jtbd-modal--image.is-open { opacity: 1; }
.jtbd-modal--image > * { pointer-events: auto; }
.jtbd-modal-image {
  display: block;
  width: auto;
  height: auto;
  max-width: min(1100px, 92vw);
  max-height: 74vh;
  object-fit: contain;
  border-radius: 12px;
  cursor: default;
  transform-origin: center center;
  transition: transform 0.25s ease;
}
/* Фигура: кнопки скачивания и закрытия привязаны к самому изображению,
   а не к краю экрана */
.jtbd-modal-figure {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: auto; /* центр, пока влезает; при увеличении остаются доступны оба края */
  line-height: 0;
  user-select: none;
}
.jtbd-modal-figure.is-zoomable { cursor: grab; }
.jtbd-modal-figure.is-zoomable .jtbd-modal-image { cursor: grab; }
.jtbd-modal-figure.is-dragging { cursor: grabbing; }
.jtbd-modal-figure.is-dragging .jtbd-modal-image { cursor: grabbing; }
.jtbd-modal-figure .jtbd-img-actions {
  top: 12px;
  right: 12px;
}
/* Масштаб изображения снизу — панель закреплена на экране, чтобы не съезжала при зуме */
.jtbd-modal-zoom {
  position: fixed;
  left: 50%;
  bottom: 24px;
  transform: translateX(-50%);
  z-index: 100002;
  display: flex;
  align-items: center;
  gap: 10px;
}
.jtbd-modal-zoom .jtbd-img-btn {
  width: 38px;
  height: 38px;
  font: 500 20px/1 Inter, sans-serif;
}
.jtbd-modal-zoom-label {
  min-width: 54px;
  color: #fff;
  font: 500 14px/1 Inter, sans-serif;
  text-align: center;
  opacity: 0.85;
}
.jtbd-modal-image-title {
  max-width: min(1100px, 92vw);
  margin: 0 auto;
  color: #fff;
  font: 400 20px/1.35 Inter, sans-serif;
  text-align: center;
}
.jtbd-modal--image .jtbd-modal-close {
  position: static;
  top: auto;
  right: auto;
  font-size: 24px;
  background: rgba(16, 16, 16, 0.38);
}
.jtbd-modal--image .jtbd-modal-close:hover { background: rgba(18, 18, 18, 0.7); }
/* Кнопки поверх картинки — «Скачать» и «Закрыть»: стильные, полупрозрачные,
   в правом верхнем углу. Появляются при движении мыши и плавно гаснут, когда
   мышь останавливается (класс is-visible ставит скрипт). */
.jtbd-img-actions {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 4;
  display: flex;
  gap: 8px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.4s ease;
}
.jtbd-img-actions.is-visible {
  opacity: 1;
  pointer-events: auto;
}
.jtbd-img-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: rgba(16, 16, 16, 0.38);
  color: #fff;
  font: 22px/1 Inter, sans-serif;
  cursor: pointer;
  -webkit-backdrop-filter: blur(10px) saturate(140%);
  backdrop-filter: blur(10px) saturate(140%);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.34), 0 4px 16px rgba(0, 0, 0, 0.28);
  transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}
.jtbd-img-btn:hover {
  background: rgba(16, 16, 16, 0.6);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.55), 0 4px 18px rgba(0, 0, 0, 0.34);
}
.jtbd-img-btn:active { transform: scale(0.94); }
.jtbd-img-btn svg {
  width: 21px;
  height: 21px;
  display: block;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.45));
}
.jtbd-img-btn.is-done {
  background: rgba(24, 124, 70, 0.8);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.5), 0 4px 16px rgba(0, 0, 0, 0.28);
}
/* Превью-плитка: кнопка скачивания появляется при наведении */
.jtbd-lesson .thumb-wrap { position: relative; display: block; }
.jtbd-lesson .thumb-wrap .jtbd-img-actions {
  top: 10px;
  right: 10px;
}
.jtbd-lesson .thumb-wrap:hover .jtbd-img-actions,
.jtbd-lesson .thumb-wrap:focus-within .jtbd-img-actions {
  opacity: 1;
  pointer-events: auto;
}
.jtbd-lesson .thumb {
  background: #e4e4e4;
  display: block;
  width: 100%;
  object-fit: cover;
}
.jtbd-lesson .thumb--round { border-radius: 20px; }
.jtbd-lesson a.item,
.jtbd-lesson article.item {
  color: inherit;
  text-decoration: none;
  display: block;
  min-width: 0;
}
.jtbd-lesson article.item--popup { cursor: pointer; }
.jtbd-lesson .lectures { padding: 19px 16px 22px; }
.jtbd-lesson .lectures-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 16px;
  row-gap: 20px;
  align-items: start;
  margin-top: 8px;
}
.jtbd-lesson .lectures-grid > .item,
.jtbd-lesson .lectures-grid > .add-card,
.jtbd-lesson .materials-row > .item,
.jtbd-lesson .materials-row > .add-card {
  width: 100%;
  min-width: 0;
  max-width: 100%;
}
.jtbd-lesson .workshops-row > .item,
.jtbd-lesson .workshops-row > .add-card {
  width: 100%;
  max-width: 100%;
  min-width: 0;
}
.jtbd-lesson img.thumb {
  width: 100%;
  max-width: 100%;
  height: auto;
  object-fit: cover;
}
.jtbd-lesson .lectures .thumb { aspect-ratio: 254 / 140; }
.jtbd-lesson .lectures .item-title { min-height: 0; }
.jtbd-lesson .workshops { padding: 19px 16px 22px; }
.jtbd-lesson .workshops-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 16px;
  row-gap: 20px;
  align-items: start;
  margin-top: 8px;
}
.jtbd-lesson .workshops-row + .workshops-row { margin-top: 20px; }
.jtbd-lesson .workshops .thumb {
  width: 100%;
  max-width: 100%;
  aspect-ratio: 254 / 140;
}
.jtbd-lesson .workshops .item-title { min-height: 0; }
.jtbd-lesson .materials { padding: 27px 24px 28px; }
.jtbd-lesson .materials-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
  justify-items: stretch;
  gap: 16px;
  margin-top: 14px;
}
.jtbd-lesson .materials .thumb,
.jtbd-lesson .guide .thumb { aspect-ratio: 254 / 140; }
/* Картинки-попапы (инструкция) — исходное соотношение, чтобы не резались */
.jtbd-lesson article.item--popup .thumb {
  aspect-ratio: auto;
  height: auto;
  object-fit: contain;
  background: transparent;
}
.jtbd-lesson .materials .item-title,
.jtbd-lesson .guide .item-title { margin-top: 14px; }
.jtbd-lesson .homework { padding: 26px 34px 28px; }
.jtbd-lesson .hw {
  margin-top: 23px;
  max-width: 100%;
  min-width: 0;
  font-size: 17px;
  line-height: 1.25;
  overflow-wrap: break-word;
  word-break: normal;
  hyphens: manual;
  -webkit-hyphens: manual;
}
.jtbd-lesson .hw,
.jtbd-lesson .hw * {
  max-width: 100%;
  white-space: normal !important;
  overflow-wrap: break-word;
  word-break: normal;
  hyphens: manual;
  -webkit-hyphens: manual;
}
.jtbd-lesson .hw p { margin: 0 0 0.8em; }
.jtbd-lesson .hw p:empty { margin: 0; min-height: 1.15em; }
.jtbd-lesson .hw > *:last-child { margin-bottom: 0; }
.jtbd-lesson .hw .stage { margin: 0; font-weight: 700; }
.jtbd-lesson .hw ul { margin: 0; padding-left: 1.35em; }
.jtbd-lesson .hw li { margin: 0; }
.jtbd-lesson .hw li > ul { margin: 0; }
.jtbd-lesson .hw strong { font-weight: 700; }
.jtbd-lesson .field,
.jtbd-lesson .guide { padding: 27px 30px 24px; }
.jtbd-lesson .field-box {
  display: block;
  width: 100%;
  height: 81px;
  margin-top: 13px;
  padding: 8px 10px;
  border: 2px solid #dbdbdb;
  border-radius: 0;
  background: #fff;
  font: 15px/1.3 Inter, sans-serif;
  resize: vertical;
}
.jtbd-lesson .guide-text {
  margin: 8px 0 0;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.25;
}
.jtbd-lesson .guide-text + .guide-text { margin-top: 13px; }
@media (max-width: 1100px) {
  .jtbd-lesson .lectures-grid { grid-template-columns: 1fr; row-gap: 20px; }
  .jtbd-lesson .workshops-row { grid-template-columns: 1fr; row-gap: 20px; }
  .jtbd-lesson .materials-row { grid-template-columns: 1fr; row-gap: 20px; }
}
@media (max-width: 720px) {
  .jtbd-lesson .page { padding: 12px 12px 28px; }
  .jtbd-lesson .frame { padding: 24px 16px 32px; border-radius: 16px; }
  .jtbd-lesson .frame-title { font-size: 20px; }
  .jtbd-lesson .frame-lead { font-size: 16px; }
  .jtbd-lesson .card { margin-top: 16px; border-radius: 16px; }
  .jtbd-lesson .lectures,
  .jtbd-lesson .workshops,
  .jtbd-lesson .materials,
  .jtbd-lesson .homework,
  .jtbd-lesson .field,
  .jtbd-lesson .guide { padding: 16px; }
  .jtbd-lesson .lectures-grid,
  .jtbd-lesson .workshops-row,
  .jtbd-lesson .materials-row { grid-template-columns: 1fr; }
  .jtbd-lesson .lectures .item-title,
  .jtbd-lesson .workshops .item-title { min-height: 0; }
  .jtbd-lesson .hw { font-size: 15px; }
}
@media (max-width: 480px) {
  .jtbd-lesson .thumb--round { border-radius: 12px; }
}
`.trim()

const embedCss = `
.jtbd-lesson {
  contain: inline-size;
  width: 100%;
  max-width: 100%;
  background: transparent;
  color: #333;
  font-family: inherit;
}
.jtbd-lesson .page {
  max-width: 100%;
  margin: 0;
  padding: 0;
}
.jtbd-lesson .frame {
  background: transparent;
  border-radius: 0;
  padding: 4px 0 8px;
}
.jtbd-lesson .frame-title,
.jtbd-lesson .frame-lead,
.jtbd-lesson .card-title,
.jtbd-lesson .item-title,
.jtbd-lesson .caption,
.jtbd-lesson .guide-text,
.jtbd-lesson .hw,
.jtbd-lesson .field-box {
  font-family: inherit;
}
.jtbd-lesson .hw,
.jtbd-lesson .hw * {
  word-break: normal !important;
  overflow-wrap: break-word !important;
  hyphens: manual !important;
  -webkit-hyphens: manual !important;
}
.jtbd-lesson .card.field #lessonAnswerForm {
  margin-top: 13px;
}
.jtbd-lesson .card.field .answer-form,
.jtbd-lesson .card.field .answer-form-inner,
.jtbd-lesson .card.field .answer-textarea-container,
.jtbd-lesson .card.field .emoji-container,
.jtbd-lesson .card.field .form-group {
  width: 100%;
  max-width: 100%;
}
.jtbd-lesson .card.field textarea {
  width: 100% !important;
  max-width: 100%;
  min-height: 100px;
  box-sizing: border-box;
}
`.trim()

function esc(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

function textHtml(value) {
  return esc(value).replace(/\n/g, '<br>')
}

function paragraphHtml(value) {
  const raw = String(value == null ? '' : value)
  if (!raw.trim()) return ''
  return raw
    .split(/\n\s*\n/)
    .map((para) => para.replace(/^\n+|\n+$/g, ''))
    .filter((para) => para.length)
    .map((para) => `<p class="text-para">${esc(para).replace(/\n/g, '<br>')}</p>`)
    .join('')
}

/** Иконка «скачать» для кнопки на картинке */
const DOWNLOAD_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3v12"></path><path d="M7 10l5 5 5-5"></path><path d="M4 19h16"></path></svg>'

/** Имя файла для скачивания: из названия карточки, расширение — из ссылки */
function imageFileName(url, title) {
  const path = String(url || '').split('?')[0].split('#')[0]
  const base = path.substring(path.lastIndexOf('/') + 1)
  const extMatch = base.match(/\.(jpe?g|png|webp|gif|avif)$/i)
  const ext = extMatch ? extMatch[1].toLowerCase() : 'jpg'
  const name = String(title || base || 'image')
    .replace(/\.[a-z0-9]+$/i, '')
    .replace(/[\\/:*?"<>|]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 80)
  return (name || 'image') + '.' + ext
}

function thumbHtml(item, round) {
  const cls = round ? 'thumb thumb--round' : 'thumb'
  const alt = esc(item.title || '')
  if (item.coverUrl) {
    return `<img class="${cls}" src="${esc(item.coverUrl)}" alt="${alt}">`
  }
  return `<div class="${cls}" role="img" aria-label="${alt}"></div>`
}

function itemHtml(item, options) {
  const inner = `${thumbHtml(item, options.round)}<h3 class="item-title">${textHtml(item.title)}</h3>${
    options.caption ? `<div class="caption">${paragraphHtml(item.description)}</div>` : ''
  }`
  const href = String(item.url || '').trim()
  if (!href) return `<article class="item">${inner}</article>`
  return `<a class="item" href="${esc(href)}" target="_blank" rel="noopener noreferrer">${inner}</a>`
}

/** Карточка инструкции: только обложка и название, открывается попапом с картинкой (ссылка не нужна) */
function guideItemHtml(item) {
  const coverUrl = String(item.coverUrl || '').trim()
  const downloadBtn = coverUrl
    ? `<span class="jtbd-img-actions">` +
        `<button type="button" class="jtbd-img-btn" data-download="${esc(coverUrl)}"` +
        ` data-download-name="${esc(imageFileName(coverUrl, item.title))}"` +
        ` aria-label="Скачать изображение" title="Скачать изображение">${DOWNLOAD_ICON}</button>` +
      `</span>`
    : ''
  const inner = `<span class="thumb-wrap">${thumbHtml(item, false)}${downloadBtn}</span><h3 class="item-title">${textHtml(item.title)}</h3>`
  return `<article class="item item--popup" data-modal-title="${esc(item.title || '')}" data-modal-image="${esc(item.coverUrl || '')}">${inner}</article>`
}

function chunk(list, size) {
  const rows = []
  const items = Array.isArray(list) ? list : []
  for (let i = 0; i < items.length; i += size) rows.push(items.slice(i, i + size))
  return rows.length ? rows : [[]]
}

const RU_VOWELS = 'аеёиоуыэюяАЕЁИОУЫЭЮЯ'
const RU_STICKY = 'йьъЙЬЪ'

function hyphenateWord(word) {
  if (word.length < 4) return word
  const vowels = []
  for (let i = 0; i < word.length; i += 1) {
    if (RU_VOWELS.indexOf(word[i]) !== -1) vowels.push(i)
  }
  if (vowels.length < 2) return word
  const points = []
  for (let v = 0; v < vowels.length - 1; v += 1) {
    const consStart = vowels[v] + 1
    const consEnd = vowels[v + 1] - 1
    let br = consStart
    if (consEnd >= consStart) {
      br = consEnd
      while (br > consStart && RU_STICKY.indexOf(word[br]) !== -1) br -= 1
      if (RU_STICKY.indexOf(word[br]) !== -1) br += 1
    }
    if (br >= 2 && word.length - br >= 2) points.push(br)
  }
  if (!points.length) return word
  let out = ''
  let prev = 0
  points.forEach((br) => {
    out += word.slice(prev, br) + '\u00AD'
    prev = br
  })
  return out + word.slice(prev)
}

function hyphenateHtml(html) {
  return String(html || '').replace(/[^<]+/g, (text) => text.replace(/[А-Яа-яЁё]{4,}/g, hyphenateWord))
}

function hasContent(html) {
  return Boolean(String(html || '').replace(/<[^>]*>/g, '').trim())
}

function buildSnippet(lesson) {
  const data = lesson || {}
  const guide = data.guide || {}
  const lectures = (data.lectures || []).map((item) => itemHtml(item, { round: true, caption: true })).join('\n')
  const workshopRows = chunk(data.workshops, 2)
    .map((row) => `<div class="workshops-row">${row.map((item) => itemHtml(item, { round: true, caption: true })).join('\n')}</div>`)
    .join('\n')
  const materials = (data.materials || []).map((item) => itemHtml(item, { round: false, caption: false })).join('\n')
  const guideMaterials = (guide.materialsList || []).map((item) => guideItemHtml(item)).join('\n')
  const guideMaterialsNote = guideMaterials ? '' : String(guide.materials || '').trim()
  const homework = hyphenateHtml(data.homeworkHtml)
  const lead = hyphenateHtml(data.lead)
  const hasLectures = Array.isArray(data.lectures) && data.lectures.length > 0
  const hasWorkshops = Array.isArray(data.workshops) && data.workshops.length > 0
  const hasMaterials = Array.isArray(data.materials) && data.materials.length > 0
  const hasHomework = hasContent(data.homeworkHtml)
  const hasGuide = Boolean(String(guide.description || '').trim() || guideMaterials || guideMaterialsNote)
  const lecturesSection = hasLectures ? `<section class="card lectures">
        <h2 class="card-title">Эфиры и лекции</h2>
        <div class="lectures-grid">
          ${lectures}
        </div>
      </section>` : ''
  const workshopsSection = hasWorkshops ? `<section class="card workshops">
        <h2 class="card-title">Воркшопы, бизнес-экскурсии и насмотренность</h2>
        ${workshopRows}
      </section>` : ''
  const materialsSection = hasMaterials ? `<section class="card materials">
        <h2 class="card-title">Материалы и доп.файлы</h2>
        <div class="materials-row">
          ${materials}
        </div>
      </section>` : ''
  const homeworkSection = hasHomework ? `<section class="card homework">
        <h2 class="card-title">Домашнее задание</h2>
        <div class="hw">${homework}</div>
      </section>` : ''
  const guideSection = hasGuide ? `<section class="card guide">
        <h2 class="card-title">Инструкция для работы в группе</h2>
        <div class="guide-text">${paragraphHtml(guide.description)}</div>
        ${guideMaterials
          ? `<div class="materials-row">${guideMaterials}</div>`
          : guideMaterialsNote ? `<div class="guide-text">${paragraphHtml(guideMaterialsNote)}</div>` : ''}
      </section>` : ''

  return `<style>\n${lessonCss}\n${embedCss}\n</style>
<div class="jtbd-lesson" lang="ru">
  <div class="page">
    <article class="frame">
      <h1 class="frame-title">${textHtml(data.title)}</h1>
      <div class="frame-lead">${lead}</div>
      ${lecturesSection}
      ${workshopsSection}
      ${materialsSection}
      ${homeworkSection}
      <section class="card field">
        <h2 class="card-title">Поле для ДЗ</h2>
        ${data.fieldNote ? `<div class="guide-text">${paragraphHtml(data.fieldNote)}</div>` : ''}
        <textarea class="field-box" aria-label="Поле для домашнего задания"></textarea>
      </section>
      ${guideSection}
    </article>
  </div>
</div>
<script>
(function () {
  var root = document.currentScript && document.currentScript.previousElementSibling;
  if (!root || !root.classList || !root.classList.contains('jtbd-lesson') || root.getAttribute('data-jtbd-ready')) return;
  root.setAttribute('data-jtbd-ready', '1');

  function mountAnswerForm() {
    var slot = root.querySelector('.card.field');
    var form = document.getElementById('lessonAnswerForm');
    if (!slot || !form || slot.contains(form)) return;
    var placeholder = slot.querySelector('.field-box');
    if (placeholder && placeholder.parentNode) placeholder.parentNode.removeChild(placeholder);
    slot.appendChild(form);
    var mission = document.querySelector('[class*="mission-deadline-removable-block"]');
    if (mission && !mission.contains(form)) mission.style.display = 'none';
  }
  mountAnswerForm();
  document.addEventListener('DOMContentLoaded', mountAnswerForm);
  window.addEventListener('load', mountAnswerForm);

  var KINESCOPE_PATH_KEYWORDS = ['video', 'videos', 'embed', 'detail', 'player', 'watch', 'edit'];

  function kinescopeId(link) {
    var value = String(link || '').trim();
    if (!/^https?:\\/\\//i.test(value)) return '';
    var url;
    try { url = new URL(value); } catch (e) { return ''; }
    if (!/(^|\\.)kinescope\\.io$/i.test(url.hostname)) return '';
    var fromQuery = url.searchParams.get('video_id') || url.searchParams.get('videoId') || url.searchParams.get('id');
    if (fromQuery) return fromQuery;
    // Формы ссылок: /{id}, /{id}/plyXXXX, /embed/{id}, /video/{id}
    // и ссылка из личного кабинета https://app.kinescope.io/video/detail/{uuid}
    var parts = url.pathname.split('/').filter(Boolean);
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i];
      if (KINESCOPE_PATH_KEYWORDS.indexOf(part.toLowerCase()) !== -1) continue;
      if (/^ply[a-zA-Z0-9_-]*$/i.test(part)) continue;
      if (/^[a-zA-Z0-9_-]{6,}$/.test(part)) return part;
    }
    return '';
  }

  var backdrop = null;
  var dialog = null;
  var playerInstance = null;
  var returnRect = null;
  var bodyOverflow = '';
  var playerSeq = 0;

  function loadKinescopeApi(callback) {
    if (window.__kinescopePlayerFactory) {
      callback(window.__kinescopePlayerFactory);
      return;
    }
    window.__kinescopeApiWaiters = window.__kinescopeApiWaiters || [];
    window.__kinescopeApiWaiters.push(callback);
    if (window.__kinescopeApiBootstrapped) return;
    window.__kinescopeApiBootstrapped = true;
    var tag = document.querySelector('script[src*="player.kinescope.io"][src*="iframe.player.js"]');
    if (!tag) {
      tag = document.createElement('script');
      tag.src = 'https://player.kinescope.io/latest/iframe.player.js';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
    window.onKinescopeIframeAPIReady = function (playerFactory) {
      window.__kinescopePlayerFactory = playerFactory;
      var waiters = window.__kinescopeApiWaiters || [];
      window.__kinescopeApiWaiters = [];
      waiters.forEach(function (cb) {
        try { cb(playerFactory); } catch (e) {}
      });
    };
  }

  function textOf(node) {
    return node ? String(node.innerText || '').trim() : '';
  }

  function closeModal(animated) {
    if (!dialog) return;
    playerSeq += 1;
    var currentDialog = dialog;
    var currentBackdrop = backdrop;
    dialog = null;
    backdrop = null;
    var currentPlayer = playerInstance;
    playerInstance = null;
    if (currentPlayer && typeof currentPlayer.destroy === 'function') {
      try { currentPlayer.destroy(); } catch (e) {}
    }
    var playerBox = currentDialog.querySelector('.jtbd-modal-player');
    if (playerBox) playerBox.textContent = '';
    currentDialog.classList.remove('is-open');
    if (currentBackdrop) currentBackdrop.classList.remove('is-open');
    if (animated && returnRect) {
      currentDialog.style.top = returnRect.top + 'px';
      currentDialog.style.left = returnRect.left + 'px';
      currentDialog.style.width = returnRect.width + 'px';
      currentDialog.style.height = returnRect.height + 'px';
      currentDialog.style.borderRadius = '20px';
    }
    window.setTimeout(function () {
      if (currentDialog.parentNode) currentDialog.parentNode.removeChild(currentDialog);
      if (currentBackdrop && currentBackdrop.parentNode) currentBackdrop.parentNode.removeChild(currentBackdrop);
      document.body.style.overflow = bodyOverflow;
    }, animated ? 460 : 0);
  }

  function buildModalShell(tile) {
    closeModal(false);
    var thumb = tile.querySelector('.thumb') || tile;
    var from = thumb.getBoundingClientRect();
    returnRect = from;
    bodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    backdrop = document.createElement('div');
    backdrop.className = 'jtbd-modal-backdrop';
    dialog = document.createElement('div');
    dialog.className = 'jtbd-modal';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');

    var player = document.createElement('div');
    player.className = 'jtbd-modal-player';

    var meta = document.createElement('div');
    meta.className = 'jtbd-modal-meta';
    var chaptersBox = document.createElement('div');
    chaptersBox.className = 'jtbd-modal-chapters';
    var title = document.createElement('h3');
    title.className = 'jtbd-modal-title';
    title.textContent = textOf(tile.querySelector('.item-title')) || tile.getAttribute('data-modal-title') || '';
    var desc = document.createElement('p');
    desc.className = 'jtbd-modal-desc';
    desc.textContent = textOf(tile.querySelector('.caption'));
    var head = document.createElement('div');
    head.className = 'jtbd-modal-head';
    head.appendChild(title);
    meta.appendChild(chaptersBox);
    if (desc.textContent) meta.appendChild(desc);

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'jtbd-modal-close';
    closeBtn.setAttribute('aria-label', 'Закрыть');
    closeBtn.textContent = '×';

    dialog.appendChild(head);
    dialog.appendChild(player);
    dialog.appendChild(meta);
    dialog.appendChild(closeBtn);
    dialog.style.top = from.top + 'px';
    dialog.style.left = from.left + 'px';
    dialog.style.width = from.width + 'px';
    dialog.style.height = from.height + 'px';
    dialog.style.borderRadius = '20px';

    document.body.appendChild(backdrop);
    document.body.appendChild(dialog);

    var finalW = Math.min(880, window.innerWidth - 40);
    var playerH = Math.round(finalW * 9 / 16);
    var finalH = Math.min(window.innerHeight - 40, playerH + 52 + 180);
    var finalLeft = Math.max(20, (window.innerWidth - finalW) / 2);
    var finalTop = Math.max(20, (window.innerHeight - finalH) / 2);

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        if (!dialog) return;
        backdrop.classList.add('is-open');
        dialog.classList.add('is-open');
        dialog.style.top = finalTop + 'px';
        dialog.style.left = finalLeft + 'px';
        dialog.style.width = finalW + 'px';
        dialog.style.height = finalH + 'px';
        dialog.style.borderRadius = '16px';
      });
    });

    backdrop.addEventListener('click', function () { closeModal(true); });
    closeBtn.addEventListener('click', function () { closeModal(true); });

    return { player: player, chaptersBox: chaptersBox };
  }

  /** Имя файла для скачивания обложки: из названия, расширение — из ссылки */
  function fileNameFor(url, title) {
    var path = String(url || '').split('?')[0].split('#')[0];
    var base = path.substring(path.lastIndexOf('/') + 1);
    var extMatch = base.match(/\.(jpe?g|png|webp|gif|avif)$/i);
    var ext = extMatch ? extMatch[1].toLowerCase() : 'jpg';
    var name = String(title || base || 'image')
      .replace(/\.[a-z0-9]+$/i, '')
      .replace(/[\\/:*?"<>|]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 80);
    return (name || 'image') + '.' + ext;
  }

  /** Скачивание картинки: сначала через blob (у fs.getcourse.ru CORS открыт),
      если не получилось — открываем картинку в новой вкладке */
  function runDownload(btn, url, name) {
    if (!url) return;
    var markDone = function () {
      if (!btn) return;
      btn.classList.add('is-done');
      setTimeout(function () { btn.classList.remove('is-done'); }, 1200);
    };
    var openInTab = function () {
      var a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.rel = 'noopener';
      a.download = name || '';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      markDone();
    };
    try {
      fetch(url, { mode: 'cors', credentials: 'omit' })
        .then(function (res) {
          if (!res.ok) throw new Error('http ' + res.status);
          return res.blob();
        })
        .then(function (blob) {
          var objectUrl = URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = objectUrl;
          a.download = name || 'image.jpg';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          setTimeout(function () { URL.revokeObjectURL(objectUrl); }, 5000);
          markDone();
        })
        .catch(openInTab);
    } catch (e) {
      openInTab();
    }
  }

  /** Кнопки поверх картинки: показываем, пока мышь двигается, плавно скрываем по простою */
  function autoHideActions(host, actions) {
    if (!host || !actions) return;
    var timer = null;
    var IDLE_MS = 2500;
    function show() {
      actions.classList.add('is-visible');
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        actions.classList.remove('is-visible');
        timer = null;
      }, IDLE_MS);
    }
    function hideNow() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      actions.classList.remove('is-visible');
    }
    host.addEventListener('mousemove', show);
    host.addEventListener('touchstart', show, { passive: true });
    host.addEventListener('mouseleave', hideNow);
    show();
  }

  function openImageModal(tile) {
    var imageUrl = tile.getAttribute('data-modal-image') || '';
    if (!imageUrl) return;

    // Своя оболочка: картинки открываются без карточки, шапки и полей плеера
    closeModal(false);
    returnRect = null;
    bodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    backdrop = document.createElement('div');
    backdrop.className = 'jtbd-modal-backdrop';

    dialog = document.createElement('div');
    dialog.className = 'jtbd-modal--image';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');

    var img = document.createElement('img');
    img.className = 'jtbd-modal-image';
    img.src = imageUrl;
    img.alt = tile.getAttribute('data-modal-title') || '';

    var titleText = textOf(tile.querySelector('.item-title')) || tile.getAttribute('data-modal-title') || '';
    var title = document.createElement('div');
    title.className = 'jtbd-modal-image-title';
    title.textContent = titleText;

    var actions = document.createElement('div');
    actions.className = 'jtbd-img-actions';

    var downloadBtn = document.createElement('button');
    downloadBtn.type = 'button';
    downloadBtn.className = 'jtbd-img-btn';
    downloadBtn.setAttribute('aria-label', 'Скачать изображение');
    downloadBtn.setAttribute('title', 'Скачать изображение');
    downloadBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3v12"></path><path d="M7 10l5 5 5-5"></path><path d="M4 19h16"></path></svg>';
    downloadBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      runDownload(downloadBtn, imageUrl, fileNameFor(imageUrl, titleText));
    });

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'jtbd-modal-close jtbd-img-btn';
    closeBtn.setAttribute('aria-label', 'Закрыть');
    closeBtn.textContent = '×';

    actions.appendChild(downloadBtn);
    actions.appendChild(closeBtn);

    // Картинка и кнопки — в одной фигуре, чтобы кнопки стояли на краю изображения
    var figure = document.createElement('div');
    figure.className = 'jtbd-modal-figure';
    figure.appendChild(img);
    figure.appendChild(actions);

    // Масштаб изображения: −/+ под картинкой
    var zoom = 1;
    var ZOOM_MIN = 0.5;
    var ZOOM_MAX = 3;
    var ZOOM_STEP = 0.25;
    var zoomBar = document.createElement('div');
    zoomBar.className = 'jtbd-modal-zoom';

    var zoomOutBtn = document.createElement('button');
    zoomOutBtn.type = 'button';
    zoomOutBtn.className = 'jtbd-img-btn';
    zoomOutBtn.setAttribute('aria-label', 'Уменьшить изображение');
    zoomOutBtn.setAttribute('title', 'Уменьшить');
    zoomOutBtn.textContent = '−';

    var zoomLabel = document.createElement('span');
    zoomLabel.className = 'jtbd-modal-zoom-label';
    zoomLabel.textContent = '100%';

    var zoomInBtn = document.createElement('button');
    zoomInBtn.type = 'button';
    zoomInBtn.className = 'jtbd-img-btn';
    zoomInBtn.setAttribute('aria-label', 'Увеличить изображение');
    zoomInBtn.setAttribute('title', 'Увеличить');
    zoomInBtn.textContent = '+';

    var panX = 0;
    var panY = 0;

    function applyTransform() {
      img.style.transform = 'scale(' + zoom + ')';
      // Фигура (вместе с кнопками на краю) едет целиком, и двигать её можно
      // свободно — без привязки к границам картинки и области просмотра
      figure.style.transform = 'translate(' + panX + 'px, ' + panY + 'px)';
    }

    function applyZoom(next) {
      zoom = Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, Math.round(next * 100) / 100));
      // Размер фигуры = размер картинки × масштаб, чтобы кнопки стояли на её краю
      var baseW = img.offsetWidth;
      var baseH = img.offsetHeight;
      if (baseW && baseH) {
        figure.style.width = Math.round(baseW * zoom) + 'px';
        figure.style.height = Math.round(baseH * zoom) + 'px';
      }
      // Вернулись к 100% — картинка возвращается на место
      if (zoom === 1) {
        panX = 0;
        panY = 0;
      }
      applyTransform();
      zoomLabel.textContent = Math.round(zoom * 100) + '%';
      zoomOutBtn.disabled = zoom <= ZOOM_MIN;
      zoomInBtn.disabled = zoom >= ZOOM_MAX;
      zoomOutBtn.style.opacity = zoomOutBtn.disabled ? '0.4' : '';
      zoomInBtn.style.opacity = zoomInBtn.disabled ? '0.4' : '';
      // перетаскивать имеет смысл только когда картинка больше области
      figure.classList.toggle('is-zoomable', zoom > 1);
    }
    // Размер известен только после загрузки картинки — пересчитываем при scale
    img.addEventListener('load', function () {
      if (zoom !== 1) applyZoom(zoom);
    });

    zoomOutBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      applyZoom(zoom - ZOOM_STEP);
    });
    zoomInBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      applyZoom(zoom + ZOOM_STEP);
    });

    zoomBar.appendChild(zoomOutBtn);
    zoomBar.appendChild(zoomLabel);
    zoomBar.appendChild(zoomInBtn);
    applyZoom(1);

    // Перетаскивание: двигаем картинку свободно, без ограничений границами
    var dragging = false;
    var dragX = 0;
    var dragY = 0;
    var startPanX = 0;
    var startPanY = 0;

    function stopDrag() {
      if (!dragging) return;
      dragging = false;
      figure.classList.remove('is-dragging');
    }

    figure.addEventListener('mousedown', function (event) {
      if (event.button !== 0 || zoom <= 1) return;
      if (event.target && event.target.closest && event.target.closest('button, a')) return;
      dragging = true;
      dragX = event.clientX;
      dragY = event.clientY;
      startPanX = panX;
      startPanY = panY;
      figure.classList.add('is-dragging');
      event.preventDefault();
    });

    window.addEventListener('mousemove', function (event) {
      if (!dragging) return;
      if (!document.body.contains(figure)) {
        stopDrag();
        return;
      }
      panX = startPanX + (event.clientX - dragX);
      panY = startPanY + (event.clientY - dragY);
      applyTransform();
      event.preventDefault();
    });
    window.addEventListener('mouseup', stopDrag);
    window.addEventListener('blur', stopDrag);

    dialog.appendChild(figure);
    dialog.appendChild(zoomBar);
    if (titleText) dialog.appendChild(title);
    autoHideActions(dialog, actions);

    document.body.appendChild(backdrop);
    document.body.appendChild(dialog);

    window.requestAnimationFrame(function () {
      if (!dialog) return;
      backdrop.classList.add('is-open');
      dialog.classList.add('is-open');
    });

    backdrop.addEventListener('click', function () { closeModal(true); });
    // Закрываем только по клику на оверлей (сам контейнер), но не по картинке
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeModal(true);
    });
    closeBtn.addEventListener('click', function () { closeModal(true); });
  }

  function openModal(link, videoId) {
    var shell = buildModalShell(link);
    var player = shell.player;
    var chaptersBox = shell.chaptersBox;
    var playerBox = document.createElement('div');
    var playerBoxId = 'jtbd-kinescope-' + (++playerSeq);
    playerBox.id = playerBoxId;
    player.appendChild(playerBox);
    var videoUrl = link.getAttribute('href') || link.getAttribute('data-modal-url') || ('https://kinescope.io/' + videoId);
    var openSeq = playerSeq;

    function formatTime(seconds) {
      var total = Math.max(0, Math.floor(Number(seconds) || 0));
      var s = total % 60;
      var m = Math.floor(total / 60) % 60;
      var h = Math.floor(total / 3600);
      var ss = (s < 10 ? '0' : '') + s;
      if (!h) return m + ':' + ss;
      var mm = (m < 10 ? '0' : '') + m;
      return h + ':' + mm + ':' + ss;
    }

    function renderChapters(player, chapters) {
      chaptersBox.textContent = '';
      chapters.forEach(function (ch) {
        var line = document.createElement('div');
        line.className = 'jtbd-modal-chapter';
        var jump = document.createElement('a');
        jump.href = '#';
        jump.textContent = formatTime(ch.position) + ' — ';
        jump.addEventListener('click', function (event) {
          event.preventDefault();
          if (!player) return;
          player.seekTo(ch.position);
          player.play();
        });
        line.appendChild(jump);
        line.appendChild(document.createTextNode(ch.title || ''));
        chaptersBox.appendChild(line);
      });
    }

    function createPlayer(playerFactory, chapters) {
      var options = {
        url: videoUrl,
        size: { width: '100%', height: '100%' },
        behavior: { autoPlay: true },
        ui: { language: 'ru', controls: true }
      };
      return playerFactory.create(playerBoxId, options).catch(function () {
        return playerFactory.create(playerBoxId, {
          url: videoUrl,
          size: { width: '100%', height: '100%' }
        });
      }).then(function (player) {
        if (openSeq !== playerSeq) {
          if (player && typeof player.destroy === 'function') player.destroy();
          return;
        }
        playerInstance = player;
        if (chapters.length) renderChapters(player, chapters);
      });
    }

    fetch('https://ncht.bz/api/kinescope-videos/' + encodeURIComponent(videoId))
      .then(function (response) { return response.ok ? response.json() : {}; })
      .then(function (payload) {
        var raw = payload && payload.data ? payload.data : payload;
        var list = raw && Array.isArray(raw.chapters) ? raw.chapters : [];
        return list.filter(function (ch) { return ch && String(ch.title || '').trim(); });
      })
      .catch(function () { return []; })
      .then(function (chapters) {
        loadKinescopeApi(function (playerFactory) {
          if (openSeq !== playerSeq || !document.getElementById(playerBoxId)) return;
          createPlayer(playerFactory, chapters);
        });
      });
  }

  root.addEventListener('click', function (event) {
    // Кнопка «скачать» на превью: не открываем попап, качаем картинку
    var dlBtn = event.target && event.target.closest ? event.target.closest('[data-download]') : null;
    if (dlBtn && root.contains(dlBtn)) {
      event.preventDefault();
      event.stopPropagation();
      runDownload(dlBtn, dlBtn.getAttribute('data-download') || '', dlBtn.getAttribute('data-download-name') || '');
      return;
    }
    var popup = event.target && event.target.closest ? event.target.closest('article.item--popup') : null;
    if (popup && root.contains(popup)) {
      event.preventDefault();
      var modalUrl = popup.getAttribute('data-modal-url') || '';
      var popupVideoId = kinescopeId(modalUrl);
      if (popupVideoId) openModal(popup, popupVideoId);
      else openImageModal(popup);
      return;
    }
    var link = event.target && event.target.closest ? event.target.closest('a.item') : null;
    if (!link || !root.contains(link)) return;
    var videoId = kinescopeId(link.getAttribute('href'));
    if (!videoId) return;
    event.preventDefault();
    openModal(link, videoId);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeModal(true);
  });
})();
</script>`
}

module.exports = { lessonCss, buildSnippet }
